



import {Component, Vue} from 'vue-property-decorator';
import Navbar from '@/components/navbar/Navbar.vue';
import TodoAdd from '@/components/todo-add/TodoAdd.vue';
import TodoList from '@/components/todo-list/TodoList.vue';
import Footer from '@/components/footer/Footer.vue';

@Component({
  components: {
    Navbar,
    TodoAdd,
    TodoList,
    Footer,
  },
})
export default class App extends Vue {
  private editing: boolean = false;

  private toggleEditing(): void {
    this.editing = !this.editing;
  }
}
